/* Independently authored navigation; native Shopify search and cart remain in charge of commerce. */
class RSHeader extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.bar = this.querySelector('.rs-header__bar');
    this.drawer = this.querySelector('.rs-menu-drawer');
    this.trigger = this.querySelector('[data-rs-menu-open]');
    this.trigger?.addEventListener('click', () => this.openMenu(), options);
    this.querySelector('[data-rs-menu-close]')?.addEventListener('click', () => this.drawer?.close(), options);
    this.drawer?.addEventListener('close', () => this.afterClose(), options);
    this.drawer?.addEventListener('click', (event) => {
      if (event.target === this.drawer) this.drawer.close();
    }, options);
    this.drawer?.addEventListener('click', (event) => {
      if (event.target.closest('a[href^="#"]')) this.drawer.close();
    }, options);
    this.querySelectorAll('.rs-mega').forEach((details) => {
      details.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.closeTimer);
        this.closeMegas(details);
        details.open = true;
      }, options);
      details.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.closeTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 150);
      }, options);
      details.addEventListener('toggle', () => {
        if (details.open) this.closeMegas(details);
        this.updateOpenState();
      }, options);
      details.addEventListener('focusout', () => {
        queueMicrotask(() => { if (!details.contains(document.activeElement)) details.open = false; });
      }, options);
    });
    this.querySelector('.rs-localization')?.addEventListener('toggle', (event) => {
      if (event.target.open) this.closeMegas(event.target);
      this.updateOpenState();
    }, options);
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeMegas();
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('.rs-mega[open], .rs-localization[open]');
      if (open) { open.open = false; open.querySelector('summary')?.focus(); event.preventDefault(); }
    }, options);
    this.update = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const compact = this.dataset.sticky === 'true' && window.scrollY > 80;
        this.classList.toggle('rs-header--compact', compact);
        this.dataset.stickyState = compact ? 'active' : 'inactive';
        const height = Math.round(this.bar?.getBoundingClientRect().height || 76);
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
        document.body.style.setProperty('--top-row-height', `${height}px`);
        document.body.style.setProperty('--transparent-header-offset-boolean', '0');
      });
    };
    window.addEventListener('scroll', this.update, { ...options, passive: true });
    window.addEventListener('resize', this.update, options);
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.contains(this)) this.closeMegas();
    }, options);
    document.addEventListener('shopify:block:select', (event) => {
      if (this.drawer?.contains(event.target)) this.openMenu();
    }, options);
    this.resizeObserver = new ResizeObserver(this.update);
    if (this.bar) this.resizeObserver.observe(this.bar);
    this.update();
  }
  closeMegas(except) {
    this.querySelectorAll('.rs-mega[open], .rs-localization[open]').forEach((details) => { if (details !== except) details.open = false; });
  }
  updateOpenState() {
    this.classList.toggle('rs-header--menu-open', !!this.querySelector('.rs-mega[open], .rs-localization[open]'));
  }
  openMenu() {
    if (!this.drawer || this.drawer.open) return;
    this.closeMegas();
    this.savedOverflow = document.documentElement.style.overflow;
    this.drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    this.trigger?.setAttribute('aria-expanded', 'true');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.drawer.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
    }
  }
  afterClose() {
    document.documentElement.style.overflow = this.savedOverflow ?? '';
    this.savedOverflow = undefined;
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.drawer?.querySelectorAll('video').forEach((video) => video.pause());
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    clearTimeout(this.closeTimer);
    if (this.frame) cancelAnimationFrame(this.frame);
    if (this.drawer?.open || this.savedOverflow !== undefined) this.afterClose();
  }
}
if (!customElements.get('rs-header')) customElements.define('rs-header', RSHeader);
